import { render, staticRenderFns } from "./ProjectOverviewVideo.vue?vue&type=template&id=30270083&scoped=true&"
import script from "./ProjectOverviewVideo.vue?vue&type=script&lang=js&"
export * from "./ProjectOverviewVideo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOverviewVideo.vue?vue&type=style&index=0&id=30270083&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30270083",
  null
  
)

export default component.exports